import { styled, Typography } from '@mui/material';
import Dialog from '@mui/material/Dialog';

export const StyledDialog = styled(Dialog, {
  shouldForwardProp: prop => prop !== '$width',
})<{ $width?: number }>(({ theme, $width = 382 }) => ({
  zIndex: 1500,
  '& .MuiDialog-paper': {
    borderRadius: 6,
    margin: 12,
    padding: 16,
    width: $width,
    maxWidth: 'calc(100% - 24px)',
    backgroundColor: theme.palette.common.white,
    position: 'relative',

    [theme.breakpoints.up('sm')]: {
      margin: 32,
      padding: 24,
      maxWidth: $width,
    },
  },
}));

export const StyledHeader = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  gap: 20,
  marginBottom: 24,
});

export const ModalTitle = styled(Typography)(({ theme }) => ({
  fontSize: 18,
  fontWeight: 450,
  lineHeight: '24px',
  color: theme.palette.common.black,
}));

export const CloseButton = styled('button')(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  padding: 0,
  border: 'none',
  background: 'transparent',
  color: theme.palette.common.black,
  cursor: 'pointer',
}));

export const Description = styled(Typography)(({ theme }) => ({
  marginBottom: 24,
  fontSize: 14,
  fontWeight: 400,
  lineHeight: 1.5,
  color: theme.palette.common.black,
}));

export const StyledActionsBox = styled('div')({
  display: 'flex',
  justifyContent: 'flex-end',
  gap: 16,
});

const actionButtonBase = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '8px 16px',
  borderRadius: 4,
  fontFamily: 'inherit',
  fontSize: 12,
  fontWeight: 500,
  lineHeight: 'normal',
  whiteSpace: 'nowrap',
  cursor: 'pointer',

  '&:disabled': {
    cursor: 'default',
    opacity: 0.4,
  },
} as const;

export const CancelButton = styled('button')(({ theme }) => ({
  ...actionButtonBase,
  border: '1px solid #EFEFEF',
  backgroundColor: theme.palette.common.white,
  color: theme.palette.common.black,

  '&:hover': { backgroundColor: '#FAFAFA' },
}));

export const ConfirmButton = styled('button')(({ theme }) => ({
  ...actionButtonBase,
  border: 'none',
  backgroundColor: theme.palette.common.black,
  color: theme.palette.common.white,
}));
